export default __webpack_public_path__ + "static/two-piece-c01e991b038ef521d68dd2e8b3c467d7.png";